/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/scram/hash-iteration': {
    put: {
      minApiVersion: 1.11,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
        minimum: 0,
        maximum: 65535,
      },
    },
  },
};
